module.exports = {"path":["dogus.eurekosigorta.com.tr","kibarholding.eurekosigorta.com.tr","/healthcheck","/en/healthcheck","\\?type=(.*)"]}


//////////////////
// WEBPACK FOOTER
// ./src/router/noindex.json
// module id = 332
// module chunks = 33